import { angleDownCircled, deleteIcon, addedIcon } from 'components/icons'

export default {
	name: 'ManageInfo',
	components: {
		angleDownCircled,
        deleteIcon,
        addedIcon,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		price: {
			type: [String, Number],
			required: true,
		},
		description: {
			type: String,
			default: '',
		},
		actionLabel: {
			type: String,
			default: '',
		},
		showDelete: {
			type: Boolean,
			default: true,
		},
		showAction: {
			type: Boolean,
			default: true,
		},
		deleteAriaLabel: {
			type: String,
			default: '',
		},
		disableDelete: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['delete', 'action'],
	computed: {
		priceDisplay() {
			if (this.price === null || this.price === undefined) {
				return ''
			}
			return typeof this.price === 'number' ? String(this.price) : this.price
		},
	},
}
